class CautivaStickyAtc extends HTMLElement {
  #abortController;
  #observer;
  #form;
  #submitBtn;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    const triggerSelector = this.getAttribute('data-trigger-selector');
    const formSelector = this.getAttribute('data-form-selector');
    const submitSelector = this.getAttribute('data-submit-selector');

    const trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
    this.#form = formSelector ? document.querySelector(formSelector) : null;
    this.#submitBtn = submitSelector ? this.querySelector(submitSelector) : null;

    if (!trigger || !this.#form) {
      this.hidden = true;
      return;
    }

    this.hidden = false;

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.removeAttribute('data-visible');
          } else {
            this.setAttribute('data-visible', 'true');
          }
        }
      },
      { root: null, threshold: 0 }
    );
    this.#observer.observe(trigger);

    if (this.#submitBtn) {
      this.#submitBtn.addEventListener('click', this.#handleSubmit, { signal });
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#abortController?.abort();
  }

  #handleSubmit = (event) => {
    if (!this.#form || this.#submitBtn.disabled) return;
    event.preventDefault();
    if (typeof this.#form.requestSubmit === 'function') {
      this.#form.requestSubmit();
    } else {
      this.#form.submit();
    }
  };
}

customElements.define('cautiva-sticky-atc', CautivaStickyAtc);
